import apiClient from './apiClient';

let csrfInitialized = false;

export const ensureCsrfCookie = async () => {
  if (csrfInitialized) return;

  await apiClient.get('/sanctum/csrf-cookie');
  csrfInitialized = true;
};
